export interface KakaoBrowserContext {
  readonly isKakao: boolean;
  readonly isAndroid: boolean;
  readonly isIOS: boolean;
}

export function detectKakaoBrowser(userAgent: string): KakaoBrowserContext {
  const isKakao = /KAKAOTALK/i.test(userAgent);
  return {
    isKakao,
    isAndroid: isKakao && /Android/i.test(userAgent),
    isIOS: isKakao && /iPhone|iPad|iPod/i.test(userAgent),
  };
}

/**
 * Android WebViews may hand an intent URL to the system browser resolver when
 * it is opened by a direct user tap. Kakao controls the host WebView, so this
 * remains a best-effort shortcut and is always paired with URL copy guidance.
 */
export function androidExternalBrowserUrl(url: string): string | null {
  const parsed = new URL(url);
  if (parsed.protocol !== 'https:') return null;
  const destination = `${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
  return `intent://${destination}#Intent;scheme=https;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;end`;
}
